// Shared marketing + placeholder content for ApnaFix.
// NOTE: Stats, testimonials & contact are PLACEHOLDERS to be replaced after launch.

export const CONTACT = {
  phone: "+91 99202 08341",
  phoneHref: "tel:+919920208341",
  whatsapp: "919920208341",
  email: "hello@apnafix.in",
};

export const whatsappLink = (text = "Hi ApnaFix, I need help with a local service.") =>
  `https://wa.me/${CONTACT.whatsapp}?text=${encodeURIComponent(text)}`;

export const HERO_IMAGE =
  "https://static.prod-images.emergentagent.com/jobs/fa55fd96-8f2d-46aa-b6f2-c3e4b2ed40e7/images/e50a6bf2188ed955eaccb23aa212450aed8a48f7a22d7c4edaae9764d6520c52.jpeg";

export const APP_MOCKUP =
  "https://static.prod-images.emergentagent.com/jobs/fa55fd96-8f2d-46aa-b6f2-c3e4b2ed40e7/images/f847ccf6e20126fa1bcbbc73d315577e44e076af4bf3ca3d44f89929d13ca0be.jpeg";

export const STEPS = [
  { n: 1, title: "Select a Service", desc: "Tell us what you need fixed.", icon: "ListChecks" },
  { n: 2, title: "Find a Local Professional", desc: "See verified professionals near you.", icon: "UserCheck" },
  { n: 3, title: "Book a Visit", desc: "Choose a convenient time slot.", icon: "CalendarClock" },
  { n: 4, title: "Get It Fixed", desc: "Pro completes the job, you pay securely.", icon: "BadgeCheck" },
];

export const FEATURES = [
  { title: "Verified Local Professionals", desc: "Background-checked & skill-tested pros.", icon: "ShieldCheck" },
  { title: "Quick Response", desc: "Fast arrival for urgent local problems.", icon: "Timer" },
  { title: "Transparent Pricing", desc: "Upfront rate card, no hidden charges.", icon: "ReceiptIndianRupee" },
  { title: "Convenient Booking", desc: "Book in under a minute, anytime.", icon: "CalendarCheck" },
  { title: "Multiple Services", desc: "All your home & local service needs.", icon: "LayoutGrid" },
  { title: "Ratings & Reviews", desc: "Choose pros your neighbours trust.", icon: "Star" },
  { title: "Digital Invoices", desc: "Every job gets a clean digital bill.", icon: "FileText" },
  { title: "Service Support", desc: "Help before, during & after the job.", icon: "Headphones" },
];

export const PARTNER_BENEFITS = [
  { title: "Get nearby customer leads", icon: "MapPin" },
  { title: "Increase your bookings", icon: "TrendingUp" },
  { title: "Manage jobs easily", icon: "ClipboardList" },
  { title: "Build your professional profile", icon: "IdCard" },
  { title: "Receive ratings and reviews", icon: "Star" },
  { title: "Track your earnings", icon: "Wallet" },
];

export const STATS = [
  { value: "1,000+", label: "Service Partners" },
  { value: "10,000+", label: "Services Completed" },
  { value: "50+", label: "Service Areas" },
  { value: "4.8/5", label: "Customer Rating" },
];

export const TESTIMONIALS = [
  { name: "Priya Sharma", area: "Kandivali West", text: "Booked an AC technician through ApnaFix and the response was very quick. Professional and polite.", rating: 5 },
  { name: "Rahul Mehta", area: "Malad", text: "My kitchen tap was leaking for days. Got a plumber the same evening at a fair price.", rating: 5 },
  { name: "Aisha Khan", area: "Borivali", text: "Electrician arrived in 20 minutes during a power trip emergency. Highly recommend.", rating: 5 },
  { name: "Sandeep Nair", area: "Goregaon", text: "Full home deep cleaning was spotless. Easy booking and transparent pricing.", rating: 4 },
];

export const FAQS = [
  { q: "How does ApnaFix work?", a: "Pick a service, enter your location, describe the problem and choose a time. We connect you with a verified local professional who completes the job." },
  { q: "How do I book a service?", a: "Tap 'Book a Service', select your service and locality, add details and a preferred time slot, then confirm with your contact number." },
  { q: "Are service professionals verified?", a: "Yes. Partners go through ID/KYC and skill verification before they can accept jobs on ApnaFix." },
  { q: "How much does a service cost?", a: "Each service shows a starting price. Final pricing is shared upfront based on the actual work, with no hidden charges." },
  { q: "Can I schedule a service for later?", a: "Absolutely. You can pick a convenient date and time slot, or choose an instant visit where available." },
  { q: "Can I cancel a booking?", a: "Yes, you can cancel from your booking confirmation. Please review our Cancellation Policy for timing details." },
  { q: "How can I become an ApnaFix partner?", a: "Tap 'Join as a Partner', fill your trade, skills, service areas and upload ID for verification. Our team reviews and activates your profile." },
  { q: "How does payment work?", a: "You pay securely after the job is completed. Online payment options are being added for added convenience." },
  { q: "Is there a service warranty?", a: "Eligible jobs come with an ApnaFix service assurance so you can book with peace of mind." },
];

export const WHY_COMPARISON = [
  { point: "Verified & background-checked pros", apnafix: true, local: false },
  { point: "Transparent upfront pricing", apnafix: true, local: false },
  { point: "Ratings & reviews you can trust", apnafix: true, local: false },
  { point: "Digital invoice & records", apnafix: true, local: false },
  { point: "Service support if something goes wrong", apnafix: true, local: false },
];

export const LIVE_FEED = [
  "Ramesh from Kandivali West just booked AC Jet Service",
  "Sunita from Malad booked Home Deep Cleaning",
  "Imran from Borivali booked an Electrician (SOS)",
  "Deepak from Goregaon booked Plumber for leakage",
  "Farah from Kandivali booked Pest Control",
  "Vijay from Malad booked Washing Machine Repair",
];
